import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appCalsiumlistSublist]',
    standalone: false
})
export class CalsiumlistSublistDirective {

    constructor(public viewContainerRef: ViewContainerRef) { }

}
